import React from 'react';
import { Linkedin, Mail, MapPin } from 'lucide-react';

export default function Footer() {
  return (
    <footer style={{ background: 'var(--sm-navy)', color: 'var(--sm-ivory)', paddingTop: 96, paddingBottom: 40 }}>
      <div className="container-x">
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 48 }} className="footer-grid">
          <div>
            <div className="serif" style={{ fontSize: 30, marginBottom: 8, letterSpacing: '0.02em', fontWeight: 600 }}>ES Investments</div>
            <div style={{ fontSize: 11, letterSpacing: '0.3em', color: 'var(--sm-gold-soft)', textTransform: 'uppercase', marginBottom: 20 }}>Management LLC · New York</div>
            <p style={{ fontSize: 14, lineHeight: 1.75, color: 'rgba(246,241,230,0.72)', maxWidth: 420 }}>
              A New York-based company connecting global sourcing with major North American retail, and a long-term investor in real estate.
            </p>
          </div>

          <div>
            <div style={{ fontSize: 11, letterSpacing: '0.28em', textTransform: 'uppercase', color: 'var(--sm-gold-soft)', marginBottom: 18 }}>Explore</div>
            {['About', 'Business', 'Investments', 'Journal'].map((l) => (
              <a key={l} href={`/#${l.toLowerCase()}`} style={{ display: 'block', color: 'rgba(246,241,230,0.85)', textDecoration: 'none', fontSize: 14, padding: '6px 0' }}>{l}</a>
            ))}
          </div>

          <div>
            <div style={{ fontSize: 11, letterSpacing: '0.28em', textTransform: 'uppercase', color: 'var(--sm-gold-soft)', marginBottom: 18 }}>Divisions</div>
            {['Apparel Distribution', 'Denim & Lifestyle', 'Real Estate Holdings'].map((l) => (
              <div key={l} style={{ color: 'rgba(246,241,230,0.85)', fontSize: 14, padding: '6px 0' }}>{l}</div>
            ))}
          </div>

          <div>
            <div style={{ fontSize: 11, letterSpacing: '0.28em', textTransform: 'uppercase', color: 'var(--sm-gold-soft)', marginBottom: 18 }}>Contact</div>
            <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start', fontSize: 14, color: 'rgba(246,241,230,0.85)', padding: '6px 0' }}>
              <MapPin size={16} style={{ marginTop: 2, color: 'var(--sm-gold-soft)' }} />
              <span>1412 Broadway<br/>New York, NY 10018</span>
            </div>
            <div style={{ display: 'flex', gap: 10, alignItems: 'center', fontSize: 14, color: 'rgba(246,241,230,0.85)', padding: '6px 0' }}>
              <Mail size={16} style={{ color: 'var(--sm-gold-soft)' }} />
              <span>office@esinvestmentsmgmt.com</span>
            </div>
            <div style={{ display: 'flex', gap: 10, alignItems: 'center', fontSize: 14, color: 'rgba(246,241,230,0.85)', padding: '6px 0' }}>
              <Linkedin size={16} style={{ color: 'var(--sm-gold-soft)' }} />
              <span>LinkedIn</span>
            </div>
          </div>
        </div>

        <div style={{ marginTop: 72, paddingTop: 24, borderTop: '1px solid rgba(246,241,230,0.12)', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12, fontSize: 12, color: 'rgba(246,241,230,0.55)', letterSpacing: '0.06em' }}>
          <div>© {new Date().getFullYear()} ES Investments Management LLC. All rights reserved.</div>
          <div style={{ display: 'flex', gap: 20 }}>
            <span>Privacy</span>
            <span>Terms</span>
            <span>Cookies</span>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .footer-grid { grid-template-columns: 1fr 1fr !important; }
        }
        @media (max-width: 600px) {
          .footer-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </footer>
  );
}
